export default {
  "批量上架": "bulkShelves",
  "更新铺货": "bulkUpdateShelves",
  "直接组合铺货": "directGroupBulkShelves",
  "加入购物车后铺货": "cartGroupBulkShelves",
  "一键生成平台资料": "one-click-create-info",
  "批量下架": "bulkUnShelve",
  "从平台店铺下载": "add-platform",
  "从快麦ERP导入": "add-kmerp",
  "手工新增商品": "add-manual",
  "excel导入商品": "add-excel",
  "修改销售价": "update-salesPrice",
  "修改市场价": "update-marketPrice",
  "修改类目和属性": "update-categoryAttrs",
  "修改库存": "update-stock",
  "修改重量": "update-weight",
  "修改商品名称": "update-name",
  "修改绑定关系": "update-bind",
  "读取对应表关系": "read-bind",
  "设为可分销": "update-enableDistribution",
  "设为不可分销": "update-disabledDistribution",
  "设为私密": "update-enablePrivacy",
  "设为公开": "update-disabledPrivacy",
  "删除商品": "bulkDel",
  "设为供销商品": "update-distirbution-goods",
  "批量修改分销价": "batch-update-distributionPrice",
  "批量修改销售价": "update-salesPrice",
  "批量关联素材包": "batch-link-material-package",
  "批量解除关联": "batch-delete-material-package",
  "批量删除": "bulkDel",
  "转为自发商品": "batch-import-goodsInfo",
  "转为分销商品": "add-to-distribute-item",
  "批量同步快麦通资料到ERP资料": "batch-sync-platform-to-system",
  "批量同步ERP资料到快麦通资料": "batch-sync-system-to-platform",
  '加入分销小店且所有人可见(公开)': "update-disabledPrivacy-enableDistribution", //可分销且公开
  '加入分销小店仅分销商可见(私密)': "update-enablePrivacy-enableDistribution", // 可分销私密
  '移出分销小店': "update-disabledDistribution", // 设为不可分销
  "改库存同步": "batch-update-stockType",
  "同步商品分类": "batch-update-autoSyncCategoryToKmt",
  '商品日志': 'prod-log',
  "提报货源": "put-goods-source",
  "商品标签管理": "goods-tag-manage",
  "批量设置商品标签":"batch-set-goods-tag",
  "批量设置展架分类": "batch-set-item-classify",
  '批量设置退货地址':'batch-set-return-address',
  '推送门店商品':'batch-push_store_prods',
  '查看门店商品':'batch-view_store_prods',
  '快捷创建分销商品规则': 'batch-bind-distributor',
  '查询诊断商品': 'query-diagnosis-product',
  'AI托管中心': 'ai-hosting-center',
};
